export const skus = {
    teamworkCollectionFree: "teamwork-collection-free-sku",
    teamworkCollectionStandard: "teamwork-collection-standard-sku",
    teamworkCollectionPremium: "teamwork-collection-premium-sku",
    teamworkCollectionEnterprise: "teamwork-collection-enterprise-sku",
    serviceCollectionFree: "service-collection-free",
    serviceCollectionStandard: "service-collection-standard",
    serviceCollectionPremium: "service-collection-premium",
    serviceCollectionEnterprise: "service-collection-enterprise"
} as const;

export type Sku = (typeof skus)[keyof typeof skus];

export interface OfferingAllowance {
    aiCredit: {
        monthly: number;
        annual: number;
    };
    indexedDocument: {
        monthly: number;
        annual: number;
    };
}
export type OfferingAllowances = Record<Sku, OfferingAllowance>;

// todo: GWP-11208 finalize constants
export const AI_CREDITS_PER_USER_INTERACTION = 10;
export const AI_CREDITS_PER_AUTOMATION = 20;

// todo: (tentative) GWP-11164 data integration to fetch offering data from contentful
export const offeringAllowances: Record<Sku, OfferingAllowance> = {
    [skus.teamworkCollectionFree]: {
        aiCredit: { monthly: 0, annual: 0 },
        indexedDocument: { monthly: 0, annual: 0 }
    },
    [skus.teamworkCollectionStandard]: {
        aiCredit: { monthly: 250, annual: 250 },
        indexedDocument: { monthly: 1000, annual: 1000 }
    },
    [skus.teamworkCollectionPremium]: {
        aiCredit: { monthly: 700, annual: 700 },
        indexedDocument: { monthly: 2500, annual: 2500 }
    },
    [skus.teamworkCollectionEnterprise]: {
        aiCredit: { monthly: 1500, annual: 1500 },
        indexedDocument: { monthly: 6250, annual: 6250 }
    },
    [skus.serviceCollectionFree]: {
        aiCredit: { monthly: 0, annual: 0 },
        indexedDocument: { monthly: 0, annual: 0 }
    },
    [skus.serviceCollectionStandard]: {
        aiCredit: { monthly: 25, annual: 25 },
        indexedDocument: { monthly: 100, annual: 100 }
    },
    [skus.serviceCollectionPremium]: {
        aiCredit: { monthly: 70, annual: 70 },
        indexedDocument: { monthly: 250, annual: 250 }
    },
    [skus.serviceCollectionEnterprise]: {
        aiCredit: { monthly: 150, annual: 150 },
        indexedDocument: { monthly: 625, annual: 625 }
    }
};
